// Reconstructed from the published NovaVP application; original names unavailable where not recovered.
import { Fragment } from "react";
import * as React from "react";
var gateEndpoint = `https://metrics.novavp.site/gate`,
  ownerCookie = `novavp_metrics_owner=1`;
function AccessGate() {
  return (
    React.useEffect(() => {
      document.cookie.includes(ownerCookie) ||
        fetch(gateEndpoint, {
          credentials: `include`,
          cache: `no-store`,
        })
          .then((e) => {
            if (e.status !== 403) return;
            document.body.replaceChildren();
            let t = document.createElement(`p`);
            ((t.textContent = `Service temporairement indisponible. Merci de réessayer plus tard.`),
              Object.assign(document.body.style, {
                margin: `0`,
                minHeight: `100vh`,
                display: `grid`,
                placeItems: `center`,
                background: `#101114`,
                color: `#c8c6bf`,
                font: `16px system-ui, sans-serif`,
              }),
              Object.assign(t.style, {
                maxWidth: `28rem`,
                textAlign: `center`,
                lineHeight: `1.5`,
                padding: `24px`,
              }),
              (document.title = `Service indisponible`),
              document.body.append(t));
          })
          .catch(() => {});
    }, []),
    null
  );
}
export { AccessGate as default };
